const getDefaultJitaiOptionalTxPackageAssignmentSetting = () => {
  return {
    assign_optional_tx_packages_rule: null,
    added_optional_tx_package_list: [],
    else_added_optional_tx_package_list: [],
    optional_modules_participant_group: null,
  }
}

export default getDefaultJitaiOptionalTxPackageAssignmentSetting
